<template>
    <div class="asl-remote-header-buttons" :class="{ ['menu-open']: globalState.menuOpen === true }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    data() {
		return {
			globalState: ar.state
		}
	},
    name: 'ASLRemoteHeaderButtonContainer',
};
</script>

<style lang="scss" scoped>
.asl-remote-header-buttons {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    position: absolute;
    top: 0;
    right: 0.25rem;
    height: 4rem;

    &.menu-open {
        /* If the hamburger menu is open, reduce the z-index so that the buttons show below the menu overlay. */
        z-index: 49;
    }
    

    & :focus {
        @include focus-outline;
    }
}

@include tp {
    .asl-remote-header-buttons {
        right: 1rem;
    }
}

@include md {
    .asl-remote-header-buttons {
        right: 1.5rem;
        height: 5.5rem;
    }
}
</style>
